// Mock data for Lucimar Rangel Bizoni website (English)

export const heroData = {
  announcement: "Transforming lives through the Word",
  title: "Lucimar Rangel F. Bizoni",
  subtitle: "Minister of the Gospel • Speaker • Financial Educator • Christian Psychotherapist",
  description: "An active voice in shaping Christian leaders, dedicated to guiding, inspiring, and transforming people by biblical principles in all areas: spirit, soul, and body.",
  ctaPrimary: "Schedule a Consultation",
  ctaSecondary: "Discover the Projects"
};

export const aboutData = {
  title: "About Lucimar",
  subtitle: "A journey of faith, purpose, and transformation",
  bio: [
    "Minister of the Gospel, Speaker, Administrator, Post-graduate in Human Resources, Neuroscience, and Human Development.",
    "Christian Psychotherapist, Writer, Behavioral Analyst, and Financial Educator.",
    "Married to Jorge Bizoni, mother of Daniel Lucas and João."
  ],
  experience: [
    {
      title: "21+ Years",
      description: "Experience in the financial market"
    },
    {
      title: "1000+ Leaders",
      description: "Trained through the ministry"
    },
    {
      title: "15+ Years",
      description: "Leading the Divas Project"
    },
    {
      title: "Since 2012",
      description: "Director of CTB Rhema Brazil"
    }
  ],
  roles: [
    "Director and teacher at the Rhema Brazil Biblical Training Center in Vitória/ES",
    "Vice-president of the Verbo da Vida Church in Vitória/ES",
    "Founder of the Divas Project",
    "Leader of the Eagles Project",
    "Leader of the Prosper Project - Business with God"
  ],
  mission: "To guide, inspire, and transform people through the biblical principles of the Word of God in all areas: spirit, soul, and body."
};

export const servicesData = {
  title: "Consulting & Mentoring",
  subtitle: "Specialized services targeting your full transformation",
  services: [
    {
      id: 1,
      title: "Christian Financial Consulting",
      description: "Financial education based on the Bible, with eternal principles for prosperity with purpose.",
      features: [
        "Purpose-driven financial planning",
        "Mentoring for individuals",
        "Mentoring for entrepreneurs",
        "Biblical principles of prosperity"
      ],
      accent: "purple"
    },
    {
      id: 2,
      title: "Christian Psychotherapy",
      description: "Emotional and spiritual support integrating faith, neuroscience, and human development.",
      features: [
        "Integral human development",
        "Emotional support",
        "Behavioral analysis",
        "Neuroscience applied to faith"
      ],
      accent: "blue"
    },
    {
      id: 3,
      title: "Psychopedagogy",
      description: "Specialized support for cognitive and emotional development based on Christian principles.",
      features: [
        "Psychopedagogical assessment",
        "Personalized intervention",
        "Family counseling",
        "Development of potential"
      ],
      accent: "orange"
    }
  ]
};

export const projectsData = {
  title: "Projects",
  subtitle: "Initiatives that transform lives and strengthen identities",
  projects: [
    {
      id: 1,
      name: "Divas Project",
      tagline: "Rescuing female identity",
      description: "For over 15 years, the Divas Project has been rescuing and strengthening female identity, helping women discover their value and purpose in God.",
      audience: "Women seeking self-knowledge and spiritual strengthening",
      accent: "pink"
    },
    {
      id: 2,
      name: "Eagles Project",
      tagline: "Flying high with firmness and constancy",
      description: "Aims at awakening and positioning women for a life of firmness, constancy, and abundance, developing leadership and purpose.",
      audience: "Women in search of growth and positioning",
      accent: "blue"
    },
    {
      id: 3,
      name: "Prosper Project",
      tagline: "Business with God",
      description: "Trains entrepreneurs and business owners in the light of the Word, uniting biblical principles with practical business strategies.",
      audience: "Christian entrepreneurs and business owners",
      accent: "green"
    }
  ]
};

export const lecturesData = {
  title: "Lectures & Conferences",
  subtitle: "Transformative messages for your church, business, or event",
  themes: [
    "Finances in the light of the Word",
    "Female identity in Christ",
    "Leadership with purpose",
    "Neuroscience and faith",
    "Integral human development",
    "Christian entrepreneurship",
    "Family and relationships",
    "Prosperity with principles"
  ],
  audiences: [
    "Churches and ministries",
    "Women's conferences",
    "Business events",
    "Leadership congresses",
    "Development seminars"
  ],
  testimonials: [
    {
      id: 1,
      quote: "Lucimar's ministration transformed my view on finances and purpose. Today I have a prosperous business based on biblical principles.",
      author: "Maria Helena",
      role: "Entrepreneur"
    },
    {
      id: 2,
      quote: "The Divas Project was a turning point in my life. I rediscovered my identity and value as a woman of God.",
      author: "Ana Paula",
      role: "Divas Project Participant"
    },
    {
      id: 3,
      quote: "Lucimar's leadership lectures are profound and practical. They impacted our entire ministerial team.",
      author: "Pastor Roberto",
      role: "Central Baptist Church"
    }
  ]
};

export const contentData = {
  title: "Contents",
  subtitle: "Articles and messages for your growth",
  articles: [
    {
      id: 1,
      title: "The 7 Biblical Principles of Prosperity",
      excerpt: "Discover the eternal foundations for a blessed financial life according to the Word of God.",
      category: "Finances",
      date: "2025-07-15"
    },
    {
      id: 2,
      title: "Identity: Who God Says You Are",
      excerpt: "A profound reflection on how the Word defines our true identity in Christ.",
      category: "Development",
      date: "2025-07-10"
    },
    {
      id: 3,
      title: "Neuroscience of Faith: How Belief Transforms the Brain",
      excerpt: "Science confirms the power of faith in mental and emotional transformation.",
      category: "Neuroscience",
      date: "2025-07-05"
    }
  ],
  devotionals: [
    {
      id: 1,
      title: "Trust in the Lord",
      verse: "Trust in the Lord with all your heart... - Proverbs 3:5-6",
      date: "2025-08-01"
    },
    {
      id: 2,
      title: "Strength and Courage",
      verse: "Be strong and courageous! Do not be terrified... - Joshua 1:9",
      date: "2025-07-30"
    }
  ]
};

export const contactData = {
  title: "Get in Touch",
  subtitle: "I am ready to help you on your transformation journey",
  email: "contato@lucimarbizoni.com.br",
  phone: "+55 27 99911-8293",
  whatsapp: "+55 27 99911-8293",
  address: "Vitória - ES, Brazil",
  social: {
    instagram: "lucimarbizoni",
    facebook: "lucimarbizoni",
    youtube: "lucimarbizoni"
  },
  formFields: [
    { name: "name", label: "Full Name", type: "text", required: true },
    { name: "email", label: "E-mail", type: "email", required: true },
    { name: "phone", label: "Phone/WhatsApp", type: "tel", required: true },
    { name: "subject", label: "Subject", type: "select", options: [
      "Financial Consulting",
      "Christian Psychotherapy",
      "Lectures and Conferences",
      "Divas Project",
      "Eagles Project",
      "Prosper Project",
      "Other"
    ], required: true },
    { name: "message", label: "Message", type: "textarea", required: true }
  ],
  sendButton: "Send Message",
  successMessage: "Message sent! I will reply shortly.",
  errorMessage: "Failed to send message. Please try again or reach out through WhatsApp."
};

export const navigationData = {
  logo: "Lucimar Rangel",
  links: [
    { label: "Home", href: "#hero" },
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Tools", href: "#tools" },
    { label: "Projects", href: "#projects" },
    { label: "Lectures", href: "#lectures" },
    { label: "Contact", href: "#contact" }
  ],
  cta: "Schedule Now"
};

export const footerData = {
  copyright: "© 2025 Lucimar Rangel F. Bizoni. All rights reserved.",
  tagline: "Transforming lives through the Word of God",
  quickLinks: [
    { label: "Financial Consulting", href: "#services" },
    { label: "Christian Psychotherapy", href: "#services" },
    { label: "Divas Project", href: "#projects" },
    { label: "Lectures", href: "#lectures" }
  ]
};

export const impactData = {
  title: "Transformative Impact",
  subtitle: "Numbers that reflect a life dedicated to the Kingdom",
  stats: [
    { value: 21, suffix: '+', label: 'Years of Experience', description: 'In the financial market and ministry', accent: 'purple' },
    { value: 1000, suffix: '+', label: 'Leaders Trained', description: 'Through CTB Rhema Brazil', accent: 'blue' },
    { value: 15, suffix: '+', label: 'Years of Divas Project', description: 'Rescuing female identities', accent: 'pink' },
    { value: 500, suffix: '+', label: 'Lectures Given', description: 'In churches and businesses', accent: 'orange' }
  ]
};
